import React, { PureComponent } from "react";
import { Link } from "react-router";
import CollapseImage from "../containers/assets/icon_collapse.svg";
import VarianceAnalysis from "../components/finance/analysis/variance-analysis";
import HelpIconButtonWithTooltipAndTypeformModal from "../components/typeform/HelpIconButtonWithTooltipAndTypeformModal";
import TypeformContent from "../components/typeform/TypeformContent";

class FinancialAnalysis extends PureComponent {
  render() {
    const { currentRound, roundInUrl, rounds } = this.props;

    return (
      <section className="analysis section-mobile bg-gray">
        <div className="row">
          <div className="col-xs-12">
            <div className="container-analysis report-collapse none-shadow">
              <h3 className="semibold">
                Financial, Planning, and Analysis
                <HelpIconButtonWithTooltipAndTypeformModal
                  {...TypeformContent.FINANCIAL_PLANNING_ANALYSIS}
                />
                <Link to="/ceo/analysis" className="icon-zoom">
                  <img
                    src={CollapseImage}
                    className="icon"
                    alt="CollapseImage"
                  />
                </Link>
              </h3>
              <div className="bg-white p-20 mt-20">
                <VarianceAnalysis
                  currentRound={currentRound}
                  roundInUrl={roundInUrl}
                  rounds={rounds}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default FinancialAnalysis;



// WEBPACK FOOTER //
// ./src/containers/financial-analysis.js